// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.88.2/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Averta-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Averta-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Averta-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/EasyReadingPRO.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Averta;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: Averta;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: Averta;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: EasyReadingPRO;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}`, "",{"version":3,"sources":["webpack://./src/styles/global/fonts.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4CAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,4CAAuC;AACzC","sourcesContent":["@font-face {\n  font-family: Averta;\n  font-weight: 400;\n  src: url('../fonts/Averta-Regular.otf');\n}\n\n@font-face {\n  font-family: Averta;\n  font-weight: 600;\n  src: url('../fonts/Averta-Semibold.otf');\n}\n\n@font-face {\n  font-family: Averta;\n  font-weight: 700;\n  src: url('../fonts/Averta-Bold.otf');\n}\n\n@font-face {\n  font-family: EasyReadingPRO;\n  src: url('../fonts/EasyReadingPRO.ttf');\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
